import React from "react";
import {
  MagnifyingGlassIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";
import ThemeSwitch from "./ThemeSwitch";
import ServerModeToggle from "./ServerModeToggle";

const ModeratorTopBar = ({
  navigationItems,
  activeTab,
  onOpenSidebar,
  searchQuery,
  onSearchChange,
  onRefresh,
  refreshLoading,
}) => {
  return (
    <div className="sales-manager-topbar sticky top-0 z-30 flex items-center">
      <div className="flex items-center justify-between px-6 w-full h-full min-h-0">
        <div className="flex items-start space-x-4 min-w-0">
          <button
            type="button"
            onClick={onOpenSidebar}
            className="lg:hidden p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-white dark:hover:bg-gray-700 transition-all duration-200"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <div className="min-w-0 flex flex-col items-start justify-center">
            <h1 className="text-2xl font-bold bg-accent-grad bg-clip-text text-transparent">
              Модерация объявлений
            </h1>
          </div>
        </div>

        <div className="flex items-center space-x-3 shrink-0">
          <div className="relative flex items-center">
            <div className="relative">
              <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-[#9CA3AC]" />
              <input
                type="text"
                placeholder="Поиск объявлений..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="pl-10 pr-4 py-2.5 rounded-lg transition-all duration-200 w-64 border bg-[#F1F5F9] border-[#CED4DA] text-[#64748B] placeholder-[#94A3B8] focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-[#1C2126] dark:border-[#333333] dark:text-[#9CA3AC] dark:placeholder-[#64748B]"
              />
            </div>
          </div>

          <ServerModeToggle inline />

          <ThemeSwitch />

          <button
            type="button"
            onClick={onRefresh}
            className="w-[46px] h-[46px] rounded-full flex items-center justify-center shrink-0 border bg-[#F1F5F9] border-[#CED4DA] text-[#64748B] hover:opacity-90 transition-all duration-200 dark:bg-[#1C2126] dark:border-[#333333] dark:text-[#9CA3AC]"
            title="Жаңарту"
          >
            <ArrowPathIcon
              className={`w-5 h-5 ${refreshLoading ? "animate-spin" : ""}`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModeratorTopBar;
